/**
 * Improved Quantity Reset Fix
 * This script resets quantity inputs immediately after cart additions
 */

(function() {
  // Track when a form is being submitted
  let submittingForm = false;
  
  // Run when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // IMMEDIATE RESET: Override value setter for quantity inputs
    document.querySelectorAll('.product-form .quantity__input').forEach(patchInput);
    
    // Watch for new inputs that might be added dynamically
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              // Check if this is a quantity input
              if (node.classList && node.classList.contains('quantity__input')) {
                patchInput(node);
              }
              // Or check its children
              const inputs = node.querySelectorAll?.('.quantity__input');
              if (inputs) {
                inputs.forEach(patchInput);
              }
            }
          });
        }
      });
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Keep track of form submissions
    document.addEventListener('submit', function(event) {
      // Only target product forms
      if (event.target.closest('.product-form') || 
          event.target.closest('product-form')) {
        
        // Find the quantity input
        const quantityInput = event.target.querySelector('.quantity__input');
        if (!quantityInput) return;
        
        // Mark that we're submitting
        submittingForm = true;
        
        // After submission is complete, unmark
        setTimeout(function() {
          submittingForm = false;
          resetQuantityToZero(quantityInput);
        }, 100);
        
        // Set up multiple rapid reset attempts
        for (let i = 1; i <= 10; i++) {
          setTimeout(function() {
            resetQuantityToZero(quantityInput);
          }, 50 * i);
        }
      }
    });
    
    // Listen for cart events
    document.addEventListener('cart:refresh', resetAllProductQuantities);
    document.addEventListener('cart:update', resetAllProductQuantities);
    
    // Reset quantities initially and periodically
    resetAllProductQuantities();
    setInterval(resetAllProductQuantities, 2000);
  });
  
  // Function to patch a quantity input with override protection
  function patchInput(input) {
    if (!input || input._patched) return;
    
    // Only patch product form inputs
    if (input.closest('.cart-items') || 
        input.closest('cart-items') || 
        input.closest('cart-drawer') || 
        input.closest('cart-drawer-items')) {
      return;
    }
    
    // Mark as patched to avoid double-patching
    input._patched = true;
    
    // Force initial value to 0
    if (input.value === "1") {
      input.value = "0";
    }
    
    // Override the value setter
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (!descriptor) return;
    
    Object.defineProperty(input, 'value', {
      get: function() {
        return descriptor.get.call(this);
      },
      set: function(newValue) {
        // If not submitting a form and trying to set to 1, force to 0
        if (!submittingForm && (newValue === "1" || newValue === 1)) {
          return descriptor.set.call(this, "0");
        }
        // Normal behavior for other cases
        return descriptor.set.call(this, newValue);
      },
      configurable: true
    });
  }
  
  // Function to reset a single quantity input to zero
  function resetQuantityToZero(input) {
    if (!input) return;
    
    // Check if this is a product form input (not a cart input)
    if (!input.closest('.cart-items') && 
        !input.closest('cart-items') && 
        !input.closest('cart-drawer') && 
        !input.closest('cart-drawer-items')) {
      
      // Reset to zero
      input.value = "0";
      
      // Dispatch a change event
      try {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        console.log("Error dispatching event:", e);
      }
    }
  }
  
  // Function to reset all product form quantity inputs
  function resetAllProductQuantities() {
    document.querySelectorAll('.quantity__input').forEach(function(input) {
      // Only reset product form inputs (not cart inputs)
      if (!input.closest('.cart-items') && 
          !input.closest('cart-items') && 
          !input.closest('cart-drawer') && 
          !input.closest('cart-drawer-items')) {
        
        // Check if this input should be patched
        if (!input._patched) {
          patchInput(input);
        }
        
        // Only reset if the value is 1
        if (input.value === "1") {
          input.value = "0";
        }
      }
    });
  }
})();